export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};



export type Query = {
  workspace?: Maybe<WorkspaceWithTests>;
  workspacesByOrgId: Array<OrgWorkspace>;
  audienceTestCounts: Array<AccountAudienceTestCount>;
  account?: Maybe<AccountWithDescendants>;
  userPermission: GroupsPermission;
  alpha: Scalars['Boolean'];
  templatesByAccount: Array<Template>;
  template: Template;
  mgtTest?: Maybe<MgtTest>;
  sharedPrototypes: Array<Prototype>;
  audience: Audience;
  organizationUsers: Array<User>;
  workspaceUsers: Array<User>;
  sharedReports: Array<SharedReports>;
  featureFlags: Array<FeatureFlag>;
  userPayload?: Maybe<UserPayload>;
  survey?: Maybe<Survey>;
  me?: Maybe<Session>;
  organizationPriority: OrganizationPriority;
  testConfig?: Maybe<TestConfig>;
  checkResetPasswordToken: CheckTokenResponse;
  searchResponses?: Maybe<SearchResults>;
};


export type QueryWorkspaceArgs = {
  id: Scalars['String'];
};


export type QueryWorkspacesByOrgIdArgs = {
  orgId: Scalars['String'];
};


export type QueryAudienceTestCountsArgs = {
  accountId: Scalars['String'];
  audienceIds: Array<Scalars['String']>;
};


export type QueryAccountArgs = {
  id: Scalars['String'];
};


export type QueryUserPermissionArgs = {
  groupId: Scalars['String'];
};


export type QueryTemplatesByAccountArgs = {
  accountId: Scalars['String'];
};


export type QueryTemplateArgs = {
  id: Scalars['String'];
  accountId: Scalars['String'];
};


export type QueryMgtTestArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
};


export type QuerySharedPrototypesArgs = {
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryAudienceArgs = {
  id: Scalars['String'];
  accountId: Scalars['String'];
};


export type QueryOrganizationUsersArgs = {
  orgId: Scalars['String'];
};


export type QueryWorkspaceUsersArgs = {
  workspaceId: Scalars['String'];
};


export type QuerySharedReportsArgs = {
  workspaceId: Scalars['String'];
  reportIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryFeatureFlagsArgs = {
  workspaceId?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
};


export type QuerySurveyArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  sharedLinkHash?: Maybe<Scalars['String']>;
};


export type QueryOrganizationPriorityArgs = {
  orgId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};


export type QueryTestConfigArgs = {
  workspaceId?: Maybe<Scalars['String']>;
  testId?: Maybe<Scalars['String']>;
  sharedLinkHash?: Maybe<Scalars['String']>;
};


export type QueryCheckResetPasswordTokenArgs = {
  token: Scalars['String'];
};


export type QuerySearchResponsesArgs = {
  searchTerm: Scalars['String'];
  workspaceId: Scalars['String'];
  questionId: Scalars['String'];
  sharedLinkHash?: Maybe<Scalars['String']>;
};

export type Mutation = {
  createWorkspace: Workspace;
  updateProject: Project;
  createProject: Project;
  createComment: UserComment;
  updateAudience?: Maybe<Audience>;
  manageResponses: ManageResponsesResult;
  createTest: Test;
  updateTest: Test;
  createCsv: CsvResponse;
  createScreenerCsv: CsvResponse;
  createTestConfig: TestConfigCreateResponse;
  toggleSharedLink: ToggleShareLinkResponse;
  changePassword: GenericResponse;
  forgotPasswordEmail: GenericResponse;
  resetPassword?: Maybe<GenericResponse>;
  indexResponses: Scalars['Boolean'];
  updateBranding?: Maybe<Branding>;
};


export type MutationCreateWorkspaceArgs = {
  name: Scalars['String'];
  iconUrl: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
  payload: UpdateProjectInput;
};


export type MutationCreateProjectArgs = {
  workspaceId: Scalars['String'];
  payload: CreateProjectInput;
};


export type MutationCreateCommentArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  payload: UserCommentInput;
};


export type MutationUpdateAudienceArgs = {
  accountId: Scalars['String'];
  audienceId: Scalars['String'];
  payload: AudienceInput;
};


export type MutationManageResponsesArgs = {
  workspaceId: Scalars['String'];
  surveyId: Scalars['String'];
  payload: ManageResponsesInput;
  pValue?: Maybe<Scalars['Int']>;
  blackListedRIDs?: Maybe<Array<Scalars['String']>>;
  minSampleCategory?: Maybe<Scalars['Int']>;
  CIpercentage?: Maybe<Scalars['Int']>;
};


export type MutationCreateTestArgs = {
  workspaceId: Scalars['String'];
  payload: CreateTestInput;
};


export type MutationUpdateTestArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  payload: UpdateTestInput;
};


export type MutationCreateCsvArgs = {
  workspaceId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCreateScreenerCsvArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
};


export type MutationCreateTestConfigArgs = {
  payload: TestConfigInput;
};


export type MutationToggleSharedLinkArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  createLink: Scalars['Boolean'];
};


export type MutationChangePasswordArgs = {
  userId: Scalars['String'];
  payload: NewPasswordPayload;
};


export type MutationForgotPasswordEmailArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  userId: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
};


export type MutationIndexResponsesArgs = {
  questionId: Scalars['String'];
};


export type MutationUpdateBrandingArgs = {
  workspaceId: Scalars['String'];
  payload: BrandingInput;
};

export enum TestStatus {
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type Session = {
  uid: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  defaultWorkspaceId: Scalars['ID'];
  workspaces: Array<Workspace>;
  featureConfig: Scalars['JSON'];
  workspaceAccessLevels: Array<WorkspaceAccessLevel>;
  orgAdminAccess?: Maybe<Array<Maybe<Scalars['String']>>>;
  admin?: Maybe<Scalars['Boolean']>;
};

export type Account = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  authDomains: Array<Scalars['String']>;
};

export type AccountWithDescendants = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  authDomains: Array<Scalars['String']>;
  organizations: Array<OrganizationWithWorkspaces>;
};

export type Organization = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type OrganizationWithWorkspaces = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  workspaces: Array<Workspace>;
};

export type Permissions = {
  id: Scalars['ID'];
  group_id: Scalars['String'];
  group_type: Scalars['String'];
  actions: Array<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  disabled_by?: Maybe<Scalars['String']>;
  disabled_at?: Maybe<Scalars['String']>;
};

export type Template = {
  id: Scalars['Int'];
  created_by?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['String']>;
  template_fields?: Maybe<Scalars['JSON']>;
  questions?: Maybe<Scalars['JSON']>;
  parent_id?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
};

export type SharedReports = {
  id: Scalars['Int'];
  reference?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  creator_email?: Maybe<Scalars['String']>;
  creator_name?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['JSON']>;
  active?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type UserPayload = {
  company: Scalars['String'];
  primary_account: Scalars['String'];
  accounts: Array<Scalars['String']>;
  firstname: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  show_tutorial?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Scalars['JSON']>;
  preferences?: Maybe<Scalars['JSON']>;
  tester?: Maybe<Scalars['String']>;
};

export type User = {
  payload: UserPayload;
  type?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  fullName: Scalars['String'];
  userName: Scalars['String'];
  abbreviation: Scalars['String'];
  email: Scalars['String'];
  admin: Scalars['Boolean'];
};

export type CreateTestInput = {
  segment?: Maybe<AudienceReferenceInput>;
  title?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  decisionContext?: Maybe<Scalars['String']>;
  customerQuestions?: Maybe<Scalars['String']>;
  status: TestStatus;
  prototypes?: Maybe<Scalars['JSON']>;
  testType?: Maybe<Scalars['String']>;
  lastSubmittedAt?: Maybe<Scalars['DateTime']>;
  activeviewid?: Maybe<Scalars['String']>;
  relatedIds?: Maybe<Array<Scalars['String']>>;
  followUp?: Maybe<Scalars['Int']>;
  renderedTemplate?: Maybe<Array<Scalars['JSON']>>;
  testTemplateId?: Maybe<Scalars['Int']>;
  templateFieldValues?: Maybe<Scalars['JSON']>;
  additional_info?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  comparison_type?: Maybe<Scalars['String']>;
};

export type UpdateTestInput = {
  segment?: Maybe<AudienceReferenceInput>;
  title?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  decisionContext?: Maybe<Scalars['String']>;
  customerQuestions?: Maybe<Scalars['String']>;
  status?: Maybe<TestStatus>;
  prototypes?: Maybe<Scalars['JSON']>;
  assets?: Maybe<Scalars['JSON']>;
  formtype?: Maybe<Scalars['String']>;
  testType?: Maybe<Scalars['String']>;
  testTemplateLaunched?: Maybe<Scalars['Boolean']>;
  lastSubmittedAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  activeviewid?: Maybe<Scalars['String']>;
  renderedTemplate?: Maybe<Array<Scalars['JSON']>>;
  testTemplateId?: Maybe<Scalars['Int']>;
  templateFieldValues?: Maybe<Scalars['JSON']>;
  auto_survey?: Maybe<Scalars['Boolean']>;
  additional_info?: Maybe<Scalars['String']>;
  comparison_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type AudienceReferenceInput = {
  title: Scalars['String'];
  id: Scalars['String'];
};

export type AudienceReference = {
  title: Scalars['String'];
  id: Scalars['String'];
};

export type Test = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: UserReference;
  title?: Maybe<Scalars['String']>;
  status: TestStatus;
  prototypes: Array<Prototype>;
  tags: Array<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  decisionContext?: Maybe<Scalars['String']>;
  customerQuestions?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<Scalars['String']>;
  audience?: Maybe<AudienceReference>;
  testTemplateId?: Maybe<Scalars['Int']>;
};

export type UserReference = {
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GroupsPermission = {
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions: PermissionsObject;
};

export type FeatureFlag = {
  title: Scalars['String'];
  key: Scalars['String'];
  description: Scalars['String'];
  level: Array<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  defaultEnabled: Scalars['Boolean'];
  overridden: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  config: Scalars['JSON'];
  defaultConfig?: Maybe<Scalars['JSON']>;
};

export type PermissionsObject = {
  templateQuestionModification?: Maybe<Array<Scalars['String']>>;
};

export type Workspace = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  projectCount: Scalars['Int'];
  testCount: Scalars['Int'];
  accountManager?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
};

export type WorkspaceAccessLevel = {
  id: Scalars['String'];
  accessLevel: Scalars['String'];
};

export type OrgWorkspace = {
  _id: Scalars['String'];
  name: Scalars['String'];
  payload: Scalars['JSON'];
  createdAt: Scalars['DateTime'];
};

export type WorkspaceWithTests = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  tests: Array<Test>;
  accountId: Scalars['ID'];
  organizationId: Scalars['ID'];
  projects: Array<Project>;
  audiences: Array<Audience>;
  accountAudiences: Array<Audience>;
  branding?: Maybe<Branding>;
  mgtWorkspace: MgtWorkspace;
};

export type Branding = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
  monochromatic: Scalars['String'];
  sequentialPalette: Scalars['String'];
  divergentPalette: Array<Scalars['String']>;
  qualitativePalette: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
};

export type MgtWorkspace = {
  id: Scalars['String'];
  name: Scalars['String'];
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  count: Scalars['Int'];
  drops: Array<Maybe<Scalars['JSON']>>;
  payload: Scalars['JSON'];
};

export type Project = {
  id: Scalars['String'];
  title: Scalars['String'];
  prototypes: Array<Prototype>;
  desc: Scalars['String'];
  audiences: Array<Scalars['String']>;
  ids: Array<Scalars['String']>;
};

export type UpdateProjectInput = {
  title?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  assets?: Maybe<Scalars['JSON']>;
  audiences?: Maybe<Array<Scalars['String']>>;
  ids?: Maybe<Array<Scalars['String']>>;
  hidden?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<DeleteProjectPropertyInput>;
};

export type DeleteProjectPropertyInput = {
  ids?: Maybe<Array<Scalars['String']>>;
  audiences?: Maybe<Array<Scalars['String']>>;
  assets?: Maybe<Array<Scalars['String']>>;
};

export type CreateProjectInput = {
  title: Scalars['String'];
  desc: Scalars['String'];
};

export type UserComment = {
  id: Scalars['String'];
  firstName: Scalars['String'];
  comment: Scalars['String'];
  userId: Scalars['String'];
};

export type UserCommentInput = {
  comment: Scalars['String'];
  taggedUsers: Array<Scalars['String']>;
};

export type BrandingInput = {
  monochromatic: Scalars['String'];
  sequentialPalette: Scalars['String'];
  divergentPalette: Array<Scalars['String']>;
  qualitativePalette: Array<Scalars['String']>;
};

export type Prototype = {
  id: Scalars['String'];
  title: Scalars['String'];
  assetType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type Audience = {
  _id: Scalars['String'];
  payload: Scalars['JSON'];
  name: Scalars['String'];
  drops: Array<Scalars['JSON']>;
};

export type AccountAudienceTestCount = {
  id?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type AudienceInput = {
  payload: Scalars['JSON'];
  name: Scalars['String'];
};

export type MgtTest = {
  followers: Array<User>;
  allUsers: Array<User>;
  comments: Array<UserComment>;
  data: Scalars['JSON'];
};

export type Survey = {
  id: Scalars['String'];
  respondents?: Maybe<Array<Respondent>>;
  questions?: Maybe<Array<Question>>;
  insights?: Maybe<InsightResponseObject>;
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export type Respondent = {
  id: Scalars['String'];
  simpleId: Scalars['String'];
  sessionId: Scalars['String'];
  age: Scalars['Int'];
  status: Scalars['String'];
  standardEmployment?: Maybe<Scalars['String']>;
  standardNumberOfEmployees?: Maybe<Scalars['String']>;
  standardHHIUS?: Maybe<Scalars['String']>;
  standardIndustryPersonal?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  standardEducation?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  msIsMobile?: Maybe<Scalars['Boolean']>;
  responses?: Maybe<Array<Response>>;
  race?: Maybe<Scalars['String']>;
  hispanicOrigin?: Maybe<Scalars['String']>;
  raceAndHispanicOrigin?: Maybe<Scalars['String']>;
};

export type Response = {
  id: Scalars['String'];
  questionId: Scalars['String'];
  respondentSurveyId?: Maybe<Scalars['String']>;
  otherAnswer?: Maybe<Scalars['String']>;
  explainAnswer?: Maybe<Scalars['String']>;
  textAnswer?: Maybe<Scalars['String']>;
  textArrayAnswer?: Maybe<Array<Maybe<Scalars['String']>>>;
  textMapAnswer?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  dataQualityCategories?: Maybe<Array<Maybe<DataQualityCategory>>>;
  sentimentLabel?: Maybe<SentimentLabel>;
  spacyPos?: Maybe<Array<Scalars['String']>>;
  spacyLemma?: Maybe<Array<Scalars['String']>>;
};

export enum DataQualityCategory {
  Allowed = 'ALLOWED',
  PersonalInfo = 'PERSONAL_INFO',
  RestrictedContent = 'RESTRICTED_CONTENT',
  Uninformative = 'UNINFORMATIVE',
  Inconsistent = 'INCONSISTENT',
  Disqualified = 'DISQUALIFIED',
  Gibberish = 'GIBBERISH',
  IncompleteSession = 'INCOMPLETE_SESSION',
  DefaultAcceptedLength = 'DEFAULT_ACCEPTED_LENGTH',
  Unknown = 'UNKNOWN'
}

export enum SentimentLabel {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
  Neutral = 'NEUTRAL'
}

export type Question = {
  id: Scalars['String'];
  type: Scalars['String'];
  order: Scalars['Int'];
  text: Scalars['String'];
  hasExplainOpt: Scalars['Boolean'];
  hasOtherOpt: Scalars['Boolean'];
  hasNaOpt: Scalars['Boolean'];
  parentQuestionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualifyingTags: Array<Maybe<Scalars['String']>>;
  scaleProperties?: Maybe<ScaleProperties>;
  scaleGroupings?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  survey?: Maybe<Survey>;
  options?: Maybe<Array<QuestionOption>>;
  assets?: Maybe<Array<QuestionAsset>>;
  responses?: Maybe<Array<Response>>;
  configuration?: Maybe<QuestionConfig>;
};

export type QuestionOption = {
  id: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  order: Scalars['Int'];
  qualificationTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  shuffle: Scalars['Boolean'];
  isTerminating: Scalars['Boolean'];
  isCorrectOption: Scalars['Boolean'];
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  configuration?: Maybe<OptionConfig>;
};

export type QuestionAsset = {
  id: Scalars['Int'];
  type: Scalars['String'];
  url: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  forceOpen: Scalars['Boolean'];
  questionId?: Maybe<Scalars['String']>;
};

export type InsightItem = {
  type: Scalars['String'];
  questionId: Scalars['String'];
  demographic?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  option: Scalars['String'];
  alpha?: Maybe<Scalars['String']>;
  magnitude?: Maybe<Scalars['String']>;
  relMagnitudes?: Maybe<Scalars['String']>;
};

export type InsightResponseObject = {
  ahash: Scalars['String'];
  workspaceId: Scalars['String'];
  testId?: Maybe<Scalars['String']>;
  surveyId: Scalars['String'];
  insights: Array<InsightItem>;
  networkTime?: Maybe<Scalars['String']>;
  processingTime?: Maybe<Scalars['String']>;
  pValue: Scalars['Float'];
  minSampleCategory: Scalars['Int'];
  CIpercentage: Scalars['Int'];
  isCached?: Maybe<Scalars['Boolean']>;
};

export type QuestionConfig = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  questionId: Scalars['String'];
  surveyId?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
  context?: Maybe<Scalars['String']>;
};

export type OptionConfig = {
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  questionOptionId: Scalars['Int'];
};

export type TestConfig = {
  id?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  findings?: Maybe<Array<Scalars['String']>>;
  sharedLinkHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  questionConfigs: Array<QuestionConfig>;
  optionConfigs: Array<OptionConfig>;
  testMetaDetails?: Maybe<TestMetaDetails>;
};

export type TestMetaDetails = {
  type: Scalars['String'];
  title: Scalars['String'];
  completedAt: Scalars['DateTime'];
  audienceId: Scalars['String'];
  workspaceId: Scalars['String'];
  audience?: Maybe<Audience>;
  workspaceIcon?: Maybe<Scalars['String']>;
  branding?: Maybe<Branding>;
};

export type TestConfigCreateResponse = {
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  configuration?: Maybe<TestConfig>;
};

export type ToggleShareLinkResponse = {
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  shareLinkHash?: Maybe<Scalars['String']>;
};

export type QuestionConfigInput = {
  title?: Maybe<Scalars['String']>;
  questionId: Scalars['String'];
  visible?: Maybe<Scalars['Boolean']>;
  context?: Maybe<Scalars['String']>;
};

export type OptionConfigInput = {
  title?: Maybe<Scalars['String']>;
  questionOptionId: Scalars['Int'];
};

export type TestConfigInput = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  surveyId: Scalars['String'];
  findings?: Maybe<Array<Scalars['String']>>;
  questionConfigs?: Maybe<Array<QuestionConfigInput>>;
  optionConfigs?: Maybe<Array<OptionConfigInput>>;
};

export type ScaleProperties = {
  maxLabel?: Maybe<Scalars['String']>;
  minLabel?: Maybe<Scalars['String']>;
  maxRating?: Maybe<Scalars['Int']>;
  minRating?: Maybe<Scalars['Int']>;
};

export type ManageResponsesInput = {
  respondents?: Maybe<Array<ManagementEventInput>>;
  responses?: Maybe<Array<ManagementEventInput>>;
};

export type ManagementEventInput = {
  id: Scalars['String'];
  status: RemovalStatus;
};

export type ManageResponsesResult = {
  success: Scalars['Boolean'];
  insights?: Maybe<InsightResponseObject>;
};

export enum RemovalStatus {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type OrganizationPriority = {
  activeTests: Array<ActiveTest>;
  priority: PriorityList;
  datedOrgTests: Array<DatedTest>;
};

export type ActiveTest = {
  id: Scalars['Int'];
  payload: PriorityTestPayload;
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  createdBy: UserReference;
  workspaceId: Scalars['String'];
};

export type PriorityListItem = {
  testId: Scalars['Int'];
  workspaceId: Scalars['String'];
  prioritizedAt?: Maybe<Scalars['Int']>;
};

export type PriorityList = {
  capacity: Scalars['Int'];
  list: Array<PriorityListItem>;
  uuid: Scalars['String'];
};

export type PriorityTestPayload = {
  status: TestStatus;
  title: Scalars['String'];
  testType: Scalars['String'];
  prioritizedAt?: Maybe<Scalars['Int']>;
  lastSubmittedAt?: Maybe<Scalars['Int']>;
};

export type DatedTest = {
  workspaceId: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CsvResponse = {
  status: Scalars['Boolean'];
  file?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type NewPasswordPayload = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type GenericResponse = {
  status: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type CheckTokenResponse = {
  status: Scalars['Boolean'];
  userId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type SearchResults = {
  total: SearchTotals;
  max_score: Scalars['Float'];
  hits: Array<SearchHit>;
};

export type SearchTotals = {
  value: Scalars['Int'];
  relation: Scalars['String'];
};

export type SearchHit = {
  _index: Scalars['String'];
  _type: Scalars['String'];
  _id: Scalars['String'];
  _score: Scalars['Float'];
  highlight?: Maybe<Highlight>;
};

export type Highlight = {
  text: Array<Scalars['String']>;
};
